import * as React from "react";
import { Modal } from "@linkfluence/core/modal";
import { User } from "@linkfluence/models/user";
import Form from "@ui-kit/profile/perso";
import { useCurrentUser } from "../user/use-cases";
import ModalAvatar from "./avatar";

const MODAL_AVATAR = "modalAvatar";

interface IProps {
  onUpdateUser: (user: Partial<User>) => void;
}

const Component = ({ onUpdateUser }: IProps) => {
  const user = useCurrentUser();
  const { open, close, ModalWrapper } = Modal.get(MODAL_AVATAR);
  const [picture, setPicture] = React.useState<{ id?: number; url?: string }>({
    id: user.pictureId,
    url: user.imageUrl,
  });
  return (
    <>
      <Form
        user={user}
        picture={picture.url}
        onOpenAvatarSelections={() => open()}
        onUpdateUser={({ name, email }) => {
          onUpdateUser({
            name,
            email,
            pictureId: picture.id,
            imageUrl: picture.url,
          });
        }}
        onCancel={() =>
          setPicture({
            id: user.pictureId,
            url: user.imageUrl,
          })
        }
      />
      <ModalWrapper>
        <ModalAvatar
          picture={picture.id}
          onCancel={() => close()}
          onValidate={(picture) => {
            setPicture(picture);
            close();
          }}
        />
      </ModalWrapper>
    </>
  );
};

export default Component;
